import React, { useEffect, useState } from 'react';
import parse from "html-react-parser";
import {
  Grid,
  Paper
} from '@material-ui/core';
import wpServices from 'Services/wpService';
import CommonLoader from 'Views/Common/CommonLoader';
import clsx from 'clsx';
import LayoutView from "Views/Common/LayoutView";
import { SectionHeader } from 'components';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
const HipaaNotice = () => {
  const [hipaaContent, setContent] = useState();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const getHipaaNotice = async () => {
        const response = await wpServices.getHipaaNotice("/legal-pages?filters[slug][$eq]=hipaa-privacy-statement&populate=*");
        setContent(response);
        setLoading(false);
    };

    getHipaaNotice();
  }, []);

  return (
    <>
      <SectionHeader
        title=""
        rightSection={
          <Paper className={clsx('widget-wrapper')} elevation={0}>

            {
              isLoading ?
                <CommonLoader />
                :
                <Grid item xs={12}>
                  {hipaaContent?.data?.revision_notice && (
                    <div style={{ 
                      marginTop: '20px', 
                      marginBottom: '24px',
                      padding: '16px 20px', 
                      backgroundColor: '#f5f5f5', 
                      borderRadius: '6px',
                      fontSize: '14px',
                      color: '#666',
                      lineHeight: '1.5'
                    }}>
                      {hipaaContent?.data?.revision_notice}
                    </div>
                  )}
                  <div style={{
                    fontSize: '20px',
                    lineHeight: '1.6',
                    color: '#333'
                  }}>
                    <style>
                    {`
                      .hipaa-content p {
                        margin: 0 0 16px 0 !important;
                        line-height: 1.6;
                        font-size: 16px;
                        color: #333;
                      }
                      .hipaa-content h1, 
                      .hipaa-content h2, 
                      .hipaa-content h3, 
                      .hipaa-content h4, 
                      .hipaa-content h5, 
                      .hipaa-content h6 {
                        margin: 24px 0 16px 0 !important;
                        font-weight: 600;
                        color: #333;
                      }
                      .hipaa-content h4 { font-size: 24px; }
                      .hipaa-content h5 { font-size: 18px; }
                      .hipaa-content h6 { font-size: 14px; }
                      .hipaa-content ul {
                        margin: 0 0 16px 0 !important;
                        padding: 0 0 0 20px;
                      }
                      .hipaa-content ul li {
                        margin: 0 0 8px 0 !important;
                        list-style: disc;
                        line-height: 1.5;
                        font-size: 16px;
                        color: #333;
                      }
                      .onlyBackend {
                        text-align: left !important;
                      }
                    `}
                    </style>
                    <div className="hipaa-content">
                      <ReactMarkdown 
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[rehypeRaw]}
                      >
                        {hipaaContent?.data?.description || ''}
                      </ReactMarkdown>
                    </div>
                  </div>
                </Grid>
            }

          </Paper>

        }
      >
      </SectionHeader>
    </>
  );
};

export default HipaaNotice;
